export default {"src":"/_next/static/media/berry-street-logo-lockup-white.15be5df7.svg","height":96,"width":519,"blurWidth":0,"blurHeight":0};